import script from "./SolicitudCitaForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SolicitudCitaForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__